import React from "react";
import AddressStoreModal from "../../pages/NewCheckout/ViewCheckout/AddressStoreModal";
import { config } from "../../config";
import { 
  Container,
  AnimationContainer,
  Title,
  SubTitle,
} from './styles';

const MultiStore: React.FC = () => {
    return (
        <Container>
            <AnimationContainer>
                <img src={config.logo} alt="ConectoVarejo" />
                <Title>Selecione a loja de preferência</Title>
                <SubTitle about="Observações">
                    <span>*Seleção obrigatória</span>
                    <span>Aviso: O catálogo e frete podem variar de acordo com a loja selecionada. </span>
                </SubTitle>

                <AddressStoreModal />
            </AnimationContainer>
        </Container>
    )
}

export default MultiStore;